<template>
  <div class="container mt-4">
    <div class="row">
      <div class="col col-md-6 col-lg-4">
        <h4>Login</h4>
        <Login @logued="loguedHandler"></Login>
      </div>
    </div>
  </div>
</template>
<script>
import Login from "src/lt-module/auth-module/Login.vue";

export default {
  components: {
    Login
  },

  // directives
  // filters

  props: {
    //
  },

  data: () => ({
    //
  }),

  computed: {
    //
  },

  watch: {
    //
  },

  mounted() {
    console.log("en comp")
  },

  methods: {
    async loguedHandler() {
      await this.$store.dispatch("getUser");
      if (this.$route.query.redirect) {
        this.$router.push({
          path: this.$route.query.redirect
        });
      } else {
        this.$router.push({ name: "home" });
      }
    }
  }
};
</script>

<style scoped></style>
